<template>
<button class="btn" @click.prevent="selectClient">Izaberi</button>
</template>

<script>
export default {
  props: {
    item: {},
  },
  methods: {
    selectClient() {
      this.stores.auth.currentClient=this.item;
    },
  }
}
</script>
